// apps/ContactForm/index.js
// Yuan Wang
// Copyright American Marine Research Company LLC 2019

import React, { Fragment, useState } from 'react';
import Typography from '@material-ui/core/Typography';
import { makeStyles, createStyles } from '@material-ui/core/styles';
import Container from '@material-ui/core/Container';
import { Button } from '@material-ui/core';
import TextField from '@material-ui/core/TextField';
import FormControl from '@material-ui/core/FormControl';
import FormHelperText from '@material-ui/core/FormHelperText';
import { validateEmail } from '../../helpers'

const useStyles = makeStyles((theme) => 
  createStyles({
    logo: {
      width: 200,
      height: 200,
      marginBottom: theme.spacing(2)
    },
    card: {
      backgroundColor: theme.palette.secondary.light,
    },
    container: {
      flexDirection: 'column',
      display: 'flex',
      paddingTop: theme.spacing(3),
      paddingBottom: theme.spacing(3),
      borderRadius: 1
    },
    tabs: {
      flex: 1,
      display: 'flex',
      // backgroundColor: 'green'
    },
    panel: {
      padding: 0
    },
    button: {
      marginTop: theme.spacing(2)
    },
    prompt: {
    },
    fullPanel: {
      minHeight: '80vh'
    }, 
    promptBox: {
      backgroundColor: theme.palette.background.level1,
      borderRadius: 1,
      padding: theme.spacing(3),
    },
    grid: {
      alignItems: 'flex-start'
    }, 
    error: {
      color: theme.palette.error.main
    }
  })
)


export default function Form({ formName, action, prompt }) {
  const classes = useStyles()
  const [ email, setEmail ] = useState("")
  const [ error, setError ] = useState(false)
  const [ comment, setComment ] = useState(null)
  const onSubmit = () => {
    console.log("onSubmit")
    if (!validateEmail(email)) {
      setComment("Hmm, check your email?")
      setError(true)
      return false
    }
    setComment("Nice!")
    setError(false)
    return true
  }
  const valid = validateEmail(email)
  return (
    <Fragment>
      <form 
        name={formName} 
        method="POST" 
        action={action}
        data-netlify="true" 
        data-netlify-honeypot="bot-field"
        >
        <Container maxWidth="xs" className={classes.container}>
          <input type="hidden" name="form-name" value={formName} />
          <TextField
            name="name"
            className={classes.textField}
            label="Name"
            // margin="normal"
          />
          <br/>
          <TextField
            name="email"
            required
            className={classes.textField}
            label={prompt}
            // margin="normal"
          />  
          <FormHelperText 
            color="inherit" 
            id="email">
            { "Where we should reply to" }
          </FormHelperText>
          <br/>
          <TextField
            required
            name="message"
            className={classes.textField}
            label="Message"
            multiline
            // margin="normal"
          />
          <br/>
          <Typography variant="caption">*required</Typography>
          <br/>
          <br/>
          <FormControl>
            <Button 
              name={"submit" }
              onClick={valid ? null : onSubmit}
              type={"submit"}

              fullWidth
              size="large"
              color="secondary" 
              variant="contained"
              value="Send Message" 
              className={classes.button}>
              Send Message
            </Button>
          </FormControl>
        </Container>
      </form>
    </Fragment>
  );
}

Form.defaultProps = {
  formName: "contact",
  action: "/thanks",
  prompt: "Email"
}
